import * as realShopifyMapper from '../../shopify/mapper';
export class ShopifyMockMapper {
    isValidResponse(rawData) {
        return rawData.data && rawData.data.products;
    }
    mapProducts(products) {
        // Direct reuse of real Shopify mapper
        return realShopifyMapper.mapProducts(products);
    }
    mapFilters(rawData, currentFilters) {
        // For Shopify, the mock data structure sends products in rawData.data.products.edges
        // The real mapper expects either products array or filters array
        if (rawData.data && rawData.data.products) {
            const products = rawData.data.products.edges.map((edge) => edge.node);
            return realShopifyMapper.mapFilters(products, currentFilters);
        }
        // If no products data, return default filters
        return realShopifyMapper.mapFilters(undefined, currentFilters);
    }
    mapMeta(rawData, page, pageSize) {
        // Direct reuse of real Shopify mapper
        return realShopifyMapper.mapMeta(rawData, page, pageSize);
    }
}
